import { Button, Flex } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const UndoDeleteNotification = ({ onUndo, handleClose }) => {
  const { t } = useTranslation('goals');

  const handleUndoClick = () => {
    onUndo();
    handleClose();
  };

  return (
    <Flex direction="column" gap="3">
      <Flex mt="6" justify="end">
        <Button size="1" variant="ghost" color="blue" onClick={handleUndoClick}>
          {t('actionButtons.undo')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default UndoDeleteNotification;
